import api from "src/api/axios";

export const getAllUnitService = async (data = null) => {
  const params = new URLSearchParams();

  if (data) {
    Object.keys(data).map((key) => {
      if (data[key]) {
        params.append(key, data[key]);
      }
    });
  }

  return api.get(`/unit?${params}`).then((result) => {
    return result.data;
  });
};

export const createUnit = (data) =>
  api.post("/unit", data).then((result) => result.data);

export const updateUnit = (id, data) =>
  api.patch(`/unit/${id}`, data).then((result) => result.data);

export const getSingleUnit = (id) =>
  api.get(`/unit/${id}`).then((result) => result.data);

export const deleteUnit = (id) =>
  api.delete(`/unit/${id}`).then((result) => result.data);
